import React from "react";
import { useNavigate } from "react-router-dom";

export default function AllQuestionRequired({ setIsNotAllQuestionAnswered }) {
  const navigate = useNavigate();
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess SubContainerFilter d-flex flex-column justify-content-center">
        <div className='TotalimgSummary'>
          <img className='fileImgSumaary1' src='/HwImg/filterNotfoundImg1.png' alt=''></img>
          <img className='fileImgSumaary2 ' src='/HwImg/filterNotfoundImg2.png' alt=''></img>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
          Please answer all the question
        </div>
        <div className="d-flex justify-content-center align-items-center mt-3">
          <button
            className="okayBtnsucess"
            onClick={() => {
              setIsNotAllQuestionAnswered(false);
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
